// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Dugp","requiredAsterisk":"Info_requiredAsterisk__1Vc0x"};